import { render, staticRenderFns } from "./MinigamesTournamentHeader.vue?vue&type=template&id=3db05ddc&scoped=true"
import script from "./MinigamesTournamentHeader.vue?vue&type=script&lang=js"
export * from "./MinigamesTournamentHeader.vue?vue&type=script&lang=js"
import style0 from "./MinigamesTournamentHeader.vue?vue&type=style&index=0&id=3db05ddc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db05ddc",
  null
  
)

export default component.exports